import { render, staticRenderFns } from "./SendMoney.vue?vue&type=template&id=87159c92&scoped=true&"
import script from "./SendMoney.vue?vue&type=script&lang=js&"
export * from "./SendMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87159c92",
  null
  
)

export default component.exports